/**
 * React Query keys for AI Service
 */
export const AI_SERVICE_QUERY_KEY = {
  taskStatus: "ai-task-status",
  downloadImage: "ai-download-image",
  debugFiles: "ai-debug-files",
} as const;
